var map = {
	"./badminton.png": 156,
	"./basketbal.png": 157,
	"./fiets2.0.png": 158,
	"./gamecontroller.png": 159,
	"./laptop.png": 160,
	"./smartboard.png": 161,
	"./sportschoen.png": 162,
	"./tv.png": 163,
	"./voetbal.png": 164,
	"./waterkoker.png": 165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 155;